import React from 'react';

import { Box, Button, Chip, Stack, Typography } from '@mui/material';
import {
  GridToolbarColumnsButton,
  GridToolbarContainer,
  GridToolbarFilterButton,
  gridFilterModelSelector,
  gridFilteredTopLevelRowCountSelector,
  gridSortModelSelector,
  useGridApiContext,
  useGridSelector,
} from '@mui/x-data-grid-pro';

import { activeFilters, describeFilter, plural } from './utils';

export default function CompetitorOffersToolbar() {
  const apiRef = useGridApiContext();
  const filterModel = useGridSelector(apiRef, gridFilterModelSelector);
  const count = useGridSelector(apiRef, gridFilteredTopLevelRowCountSelector);
  const [sort] = useGridSelector(apiRef, gridSortModelSelector);
  const order = sort ? `${sort.sort === 'asc' ? 'Fewest' : 'Most'} opportunities first` : 'Latest collected first';

  return (
    <GridToolbarContainer sx={{ p: 1, gap: 1 }}>
      <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap" useFlexGap flex={1}>
        <GridToolbarColumnsButton />
        <GridToolbarFilterButton />
        {activeFilters(filterModel).map((item) => (
          <Chip
            key={item.id}
            size="small"
            variant="outlined"
            label={describeFilter(item)}
            onClick={() => apiRef.current.showFilterPanel(item.field)}
            onDelete={() => apiRef.current.deleteFilterItem(item)}
          />
        ))}
        <Button size="small" onClick={() => apiRef.current.setFilterModel({ items: [] })}>
          Clear filters
        </Button>
      </Stack>
      <Box>
        <Typography variant="body2" color="text.secondary" whiteSpace="nowrap">
          {plural(count, 'hotel')} · {order}
        </Typography>
      </Box>
    </GridToolbarContainer>
  );
}
